const isFloat = (value: string) => value.length > 0 && !isNaN(Number(value));

export default isFloat;
